import type { ReactNode } from 'react';

export enum ToastVariant {
  success = 'success',
  info = 'info',
  error = 'error',
}

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastItem {
  id: string;
  variant: ToastVariant;
  message: string;
  /** Auto-dismiss delay in ms. */
  durationMs: number;
  /** Optional trailing action (rendered after a divider). */
  action?: ToastAction;
  /** Optional icon override; defaults to the variant icon. */
  icon?: ReactNode;
}

export interface ToastProps extends ToastItem {
  /** Called when the auto-dismiss timer elapses or the toast is closed. */
  onDismiss: (id: string) => void;
}
